import { EventBus } from 'v2/utils/event-bus'

/**
 * Lets the auth forms drive the sphere in the auth panel without threading
 * props through every auth page: the forms fire signals, the panel listens.
 */
export type AuthPanelSignal = 'pending' | 'idle' | 'error' | 'success'

export const SUCCESS_HOLD_MS = 450

const bus = new EventBus<{ AUTH_PANEL_SIGNAL: (signal: AuthPanelSignal) => void }>()

// true only while a panel is on screen and animating, so the hold never delays
// a login nobody can see the burst for (below `lg`, reduced motion, no WebGL)
let panelLive = false

export const setAuthPanelLive = (live: boolean) => {
  panelLive = live
}

export const signalAuthPanel = (signal: AuthPanelSignal) => {
  bus.emit('AUTH_PANEL_SIGNAL', signal)
}

export const onAuthPanelSignal = (handler: (signal: AuthPanelSignal) => void) =>
  bus.on('AUTH_PANEL_SIGNAL', handler)

/** Spread into a login mutation's options so the panel follows its lifecycle. */
export const authPanelSignalHandlers = {
  onMutate: () => signalAuthPanel('pending'),
  onError: () => signalAuthPanel('error'),
  onSettled: () => signalAuthPanel('idle'),
}

/**
 * Plays the panel's success burst, then runs `complete`. With no panel live it
 * runs `complete` straight away, so the only added wait is one nobody misses.
 */
export const completeAfterBurst = async (complete: () => void) => {
  if (panelLive) {
    signalAuthPanel('success')
    await new Promise((resolve) => setTimeout(resolve, SUCCESS_HOLD_MS))
  }
  complete()
}
